import { FormError } from '../../_types/globals'
import { DatabaseUser } from '../../_types/user'

/**
 * Validate the details of a user
 *
 * @param {DatabaseUser} user The user data to validate
 * @returns {FormError[]} The errors found
 *
 * @example
 * ```ts
 * const errors = validate(user)
 * ```
 */
const validate = (user: DatabaseUser) => {
  const errors: FormError[] = []

  if (user.displayName === '') {
    errors.push({
      message: 'Display Name cannot be blank!',
      elementId: 'displayName',
    })
  }

  if (user.email === '') {
    errors.push({
      message: 'Email cannot be blank!',
      elementId: 'email',
    })
  }

  return errors
}

export { validate }
